export default function timeFilter (value, props) {
  let separateValue = value.split(':')
  if (separateValue[1]?.length > 2) {
    separateValue[1] = value.substring(2,5)
  }
  if(separateValue[0] > 23) props = value.substring(0, 1)
  if(separateValue[1] > 59) props = value.substring(0, 4)
  return props
}